export default __webpack_public_path__ + "static/media/marathi_book_f.dbc84e4f.wav";